import * as yup from 'yup';
import dayjs from "dayjs";

export const ownerTypes = {
    retailer: "retailer"
}

export const validationPasswordSchema = yup.object({
    password: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('password'), null], 'Password not matched'),
})

export const validationSchema = yup.object().shape({
    username: yup
        .string()
        .required('Required'),
    firstname: yup
        .string()
        .required('Required'),
    lastname: yup
        .string()
        .required('Required'),
    // dob: yup
    //     // .string()
    //     .date("Invalid")
    //     .required("Required")
    //     .typeError("Invalid"),
    // gender: yup
    //     .string()
    //     .oneOf(['male', 'female', 'other'])
    //     .required('Required'),
    // companyname: yup
    //     .string()
    //     .required('Required'),
    // identityno: yup
    //     .string()
    //     .required('Required'),
    // code: yup
    //     .string()
    //     .required('Required'),
    email: yup
        .string()
        .email('Enter a valid email')
        .when('contactno', ([contactno], schema) => {
            return contactno ? schema : schema.required('Required')
        }),
    // .when('$other', ([other], schema) =>
    //     other === 4 ? schema.max(6) : schema,
    // )
    // .required('Required'),
    contactno: yup
        .number()
        .typeError("Please enter only number")
        // .when('email', {
        //     is: (val) => val === "",
        //     then: (schema) => schema.required('Required'),
        //     otherwise: (schema) => schema,
        // }),
        .when('email', ([email], schema) => {
            return email ? schema : schema.required('Required')
        }),
    // remark: yup
    //     .string()
    //     .required('Required'),
    // address: yup
    //     .string()
    //     .required('Required'),
    // address2: yup
    //     .string()
    //     .required('Required'),
    // postcode: yup
    //     .string()
    //     .required('Required'),
    // countryId: yup
    //     .string()
    //     .required('Required'),
    // stateId: yup
    //     .string()
    //     .required('Required'),
    // areaId: yup
    //     .string()
    //     .required('Required'),
    status: yup
        .bool()
        .required('Required')

}, [['email', 'contactno']])

export const initialPasswordValues = {
    password: "",
    passwordconfirm: "",
}

export const initialValues = {
    username: "",
    firstname: "",
    lastname: "",
    identityno: "",
    contactno: "",
    gender: "",
    dob: "",
    companyname: "",
    code: "",
    email: "",
    status: false,
    remark: "",
    address: "",
    address2: "",
    postcode: "",
    countryId: "",
    stateId: "",
    areaId: "",
}